import _regeneratorRuntime from "@babel/runtime/regenerator";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var FETCH_DEFAULTS = {
  credentials: 'include',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  } // mode: 'cors'

};

function buildUrl(host, path) {
  return host + path;
}

export function patch(_x, _x2, _x3) {
  return _patch.apply(this, arguments);
}

function _patch() {
  _patch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(host, url, body) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(buildUrl(host, url), _extends({}, FETCH_DEFAULTS, {
              method: 'PATCH',
              body: JSON.stringify(body)
            }));

          case 3:
            res = _context.sent;
            return _context.abrupt("return", processResponse(res));

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error('PATCH request error', _context.t0);
            return _context.abrupt("return", {
              error: _context.t0
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));
  return _patch.apply(this, arguments);
}

export function doDelete(_x4, _x5, _x6) {
  return _doDelete.apply(this, arguments);
}

function _doDelete() {
  _doDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(host, url, body) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return fetch(buildUrl(host, url), _extends({}, FETCH_DEFAULTS, {
              method: 'DELETE',
              body: JSON.stringify(body)
            }));

          case 3:
            res = _context2.sent;
            return _context2.abrupt("return", processResponse(res));

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            console.error('DELETE request error', _context2.t0);
            return _context2.abrupt("return", {
              error: _context2.t0
            });

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));
  return _doDelete.apply(this, arguments);
}

export function get(_x7, _x8, _x9) {
  return _get.apply(this, arguments);
}
/**
 * Submit a POST request
 * @param  {string} host
 * @param  {string} url
 * @param  {any} body body is serialized as json
 */

function _get() {
  _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(host, url, params) {
    var res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (params) {
              url += '?' + new URLSearchParams(params).toString();
            }

            _context3.prev = 1;
            _context3.next = 4;
            return fetch(buildUrl(host, url), _extends({}, FETCH_DEFAULTS, {
              method: 'GET'
            }));

          case 4:
            res = _context3.sent;
            return _context3.abrupt("return", processResponse(res));

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);
            console.error('GET request error', _context3.t0);
            return _context3.abrupt("return", {
              error: _context3.t0
            });

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 8]]);
  }));
  return _get.apply(this, arguments);
}

export function post(_x10, _x11, _x12) {
  return _post.apply(this, arguments);
}
/**
 * Process the response according to it's status code. Success responses are deserialized as json.
 * @param  {} res Response
 */

function _post() {
  _post = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(host, url, body) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return fetch(buildUrl(host, url), _extends({}, FETCH_DEFAULTS, {
              method: 'POST',
              body: JSON.stringify(body)
            }));

          case 3:
            res = _context4.sent;
            return _context4.abrupt("return", processResponse(res));

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", {
              error: _context4.t0
            });

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));
  return _post.apply(this, arguments);
}

function processResponse(_x13) {
  return _processResponse.apply(this, arguments);
}

function _processResponse() {
  _processResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(res) {
    var data, _data;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(res.status >= 200 && res.status <= 201)) {
              _context5.next = 7;
              break;
            }

            _context5.next = 3;
            return res.json();

          case 3:
            data = _context5.sent;
            return _context5.abrupt("return", {
              data: data,
              response: res
            });

          case 7:
            if (!(res.status === 400)) {
              _context5.next = 14;
              break;
            }

            _context5.next = 10;
            return res.json();

          case 10:
            _data = _context5.sent;
            return _context5.abrupt("return", {
              error: new Error(_data === null || _data === void 0 ? void 0 : _data.error),
              response: res
            });

          case 14:
            if (!(res.status === 401)) {
              _context5.next = 18;
              break;
            }

            return _context5.abrupt("return", {
              error: new Error('Not authenticated'),
              response: res
            });

          case 18:
            if (!(res.status >= 500)) {
              _context5.next = 20;
              break;
            }

            return _context5.abrupt("return", {
              error: new Error('Unexpected error occurred'),
              response: res
            });

          case 20:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _processResponse.apply(this, arguments);
}